// 查看会员信息 （礼品领取记录）
<template>
  <div>
    <div>
      <!-- 使用组件 -->
      <MemberInfo></MemberInfo>
    </div>
    <div class="header-centers">
      <div>
        <el-card class="NumberCardWidth">
          <div class="deal flex-between">
            <div class="card-text">
              <h3>礼品领取记录</h3>
            </div>
            <div class="card-button">
              <el-button class="push-button" @click="NvagetToLookMenber" icon="iconfont icon-fanhui">返回基本信息</el-button>
            </div>
          </div>
          <div class="NumberTable">
            <Table @TouchTheBottom="TouchTheBottom" :PagesData="paging" :tableData="list.tbody" :configTable="list.thead" :config="list"></Table>
          </div>
        </el-card>
      </div>
      <!-- 右侧列表相关链接 -->
      <!-- 使用封装的组件 -->
      <div class="PagesContentRight">
        <RightCard></RightCard>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { GetGiftList } from "@/api/viewMemberModule";
import Table from "/src/components/NumberTable/index.vue";
import { getcpyNo } from "@/utils/auth";
export default {
  name: "centre",
  components: {
    Table: Table,
  },
  data() {
    return {
      paging: {
        page: 1,
        size: 50,
        total: 0,
        pages: 1,
        Loading: true,
      },
      list: {
        thead: [
          //设置表头
          {
            label: "",
            prop: "CopyIndex",
            width: 50,
          },
          {
            label: "礼品单号",
            prop: "getNo",
          },
          {
            label: "门店编号",
            prop: "shopCode",
          },
          {
            label: "领取时间",
            prop: "getTime",
          },
          {
            label: "礼品名称",
            prop: "giftName",
          },
          {
            label: "核销编码",
            prop: "sKU",
          },
          {
            label: "数量",
            prop: "realQty",
          },
          {
            label: "积分兑换",
            prop: "point",
          },
          {
            label: "礼券兑换",
            prop: "coupCode",
          },
          {
            label: "销售单号",
            prop: "refBussNo",
          },
          {
            label: "实付金额",
            prop: "realAmount",
          },
        ],
        tbody: [], // 表格内容
      },
    };
  },
  created() {
    // 列表数据
    this.RGetCustSalePage();
  },
  computed: {
    ...mapState({
      custID: (state) => state.user.custID,
    }),
  },
  methods: {

    TouchTheBottom() {
      this.paging.page++;
      this.RGetCustSalePage();
    },
    RGetCustSalePage() {
      let data = require("qs").stringify({
        cpyNo: getcpyNo,
        custId: this.custID,
        pageSize: this.paging.size,
        pageNo: this.paging.page,
      });
      GetGiftList(data).then((res) => {
        if (res.success == true) {
          this.paging.total = res.totalSize;
          this.paging.pages = res.pages;
          res.records.forEach((item, index) => {

            item.CopyIndex = (this.paging.page - 1) * this.paging.size + index + 1;

          });
          this.list.tbody = this.list.tbody.concat(res.records);
        } else {
          this.$message.error(res.message);
        }
        this.paging.Loading = false;
      });
    },
    NvagetToLookMenber() {
      this.$router.push("/LookMember");
    },

  },
};
</script>
<style lang="scss" scoped>
.NumberCardWidth {
  width: 1265px;
}
.header-centers {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
.PagesContentRight {
  height: 990px;
  margin-left: 25px;
  display: flex;
  flex-direction: column;
  justify-self: flex-start;
  align-content: flex-start;
}
.NumberTable {
  margin-top: 40px;
}
.card-text {
  color: #a19b5a;
}
.push-button {
  background-color: #e9e7d3;
  border-radius: 7px;
  color: #a19b59;
}
</style>
